// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__R9YhW","text":"LoadingOverlay_text__AL7NQ","spinner":"LoadingOverlay_spinner__dINDG","spin":"LoadingOverlay_spin__Ud7yW"};